/**
 * The hands-on org is a trimmed product for a prospect to explore, so it hides
 * the menu items and tabs the session doesn't cover (Pete, 2026-10-07). It is
 * recognized by the name the seed gives it (`HCAH Hands-on <date>`), the same
 * way the home health demo layer recognizes its tenant.
 */
import { useOrganization } from "~/providers/GraphqlProvider";

export function isHandsOnOrg(organizationName?: string): boolean {
  return /^HCAH Hands-on\b/i.test(organizationName ?? "");
}

export function useHandsOnOrg(): boolean {
  const { organizationName } = useOrganization();
  return isHandsOnOrg(organizationName);
}
